<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  COMPONENT_TYPES,
  findComponentByType,
} from 'dashboard/helper/templateHelper';
import {
  templateSegments,
  variableMeta,
} from 'dashboard/helper/segurocorTemplates';

// Preview do template como o cliente vai ver no WhatsApp, com cada variável destacada no lugar.
const props = defineProps({
  template: { type: Object, required: true },
  values: { type: Object, default: () => ({}) },
  activeKey: { type: String, default: '' },
});

const { t } = useI18n();

const header = computed(() =>
  findComponentByType(props.template, COMPONENT_TYPES.HEADER)
);
const footer = computed(() =>
  findComponentByType(props.template, COMPONENT_TYPES.FOOTER)
);
const buttons = computed(
  () =>
    findComponentByType(props.template, COMPONENT_TYPES.BUTTONS)?.buttons || []
);
const segments = computed(() =>
  templateSegments(
    findComponentByType(props.template, COMPONENT_TYPES.BODY)?.text || '',
    props.values
  )
);

const variableClass = segment => {
  const active = segment.key === props.activeKey;
  if (segment.value) {
    return active
      ? 'bg-n-amber-5 text-n-slate-12 font-medium'
      : 'bg-n-amber-3 text-n-slate-12 font-medium';
  }
  return active
    ? 'outline outline-1 outline-n-amber-9 text-n-amber-11 italic'
    : 'outline outline-1 outline-dashed outline-n-slate-7 text-n-slate-10 italic';
};
</script>

<template>
  <div class="flex flex-col gap-1">
    <span class="text-xs font-medium text-n-slate-11">
      {{ t('WHATSAPP_TEMPLATES.SEGUROCOR.PREVIEW_LABEL') }}
    </span>
    <div class="flex p-3 rounded-lg bg-n-slate-3">
      <div
        class="max-w-[95%] px-3 py-2 text-sm rounded-lg rounded-tl-none shadow-sm bg-n-teal-3 text-n-slate-12"
      >
        <p
          v-if="header?.format === 'TEXT' && header.text"
          class="mb-1 font-semibold"
        >
          {{ header.text }}
        </p>
        <p
          v-else-if="header?.format"
          class="mb-1 text-xs italic text-n-slate-11"
        >
          {{
            t('WHATSAPP_TEMPLATES.SEGUROCOR.PREVIEW_MEDIA', {
              format: header.format.toLowerCase(),
            })
          }}
        </p>
        <p class="mb-0 whitespace-pre-wrap break-words">
          <template v-for="(segment, i) in segments" :key="i">
            <span v-if="segment.type === 'text'">{{ segment.text }}</span>
            <span
              v-else
              class="px-0.5 rounded transition-colors"
              :class="variableClass(segment)"
              >{{ segment.value || variableMeta(segment.key).label }}</span
            >
          </template>
        </p>
        <p v-if="footer?.text" class="mt-1 mb-0 text-xs text-n-slate-11">
          {{ footer.text }}
        </p>
      </div>
    </div>
    <div v-if="buttons.length" class="flex flex-wrap gap-1">
      <span
        v-for="button in buttons"
        :key="button.text"
        class="px-2 py-1 text-xs rounded-md bg-n-slate-3 text-n-blue-11"
      >
        {{ button.text }}
      </span>
    </div>
  </div>
</template>
